import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { type MaintenanceModuleSpecsFragment } from '../../../../../api/fragments/MaintenanceModuleSpecs';
import {
    CreateMaintenanceModuleDocument,
    type CreateMaintenanceModuleMutation,
    type CreateMaintenanceModuleMutationVariables,
} from '../../../../../api/mutations/createMaintenanceModule';
import { type MaintenanceModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import MaintenanceModulePage, { type MaintenanceModulePageProps } from '../../MaintenanceModulePage';
import { type ModuleImplementation } from './types';

const colSpan = { md: 12, xs: 24 };

const formValidator = validators.compose(validators.requiredNonEmptyString('displayName'));

type MaintenanceModuleImplementation = ModuleImplementation<MaintenanceModuleSpecsFragment, MaintenanceModuleSettings>;

const Form: MaintenanceModuleImplementation['FormComponent'] = () => {
    const { t } = useTranslation(['moduleDetails', 'maintenance']);

    return (
        <Row gutter={14}>
            <Col {...colSpan}>
                <InputField
                    {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                    name="displayName"
                    required
                />
            </Col>
        </Row>
    );
};

const implementation: MaintenanceModuleImplementation = {
    PageComponent: ({ module }: MaintenanceModulePageProps) => <MaintenanceModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.MaintenanceModule.className'),
    FormComponent: Form,
    getValidator: () => formValidator,
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateMaintenanceModuleMutation, CreateMaintenanceModuleMutationVariables>({
                mutation: CreateMaintenanceModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
    initialValues: {
        displayName: '',
    },
};

export default implementation;
